<template>
  <nav
    class="tabbar"
    v-show="$root.$data.showNavbar && !$route.path.includes('login') &&!$route.path.includes('done') && !keyboardIsVisible && !$root.canNotConnectToServer"
  >
    <ul v-if="!$route.path.includes('kid')">
      <li :class="`${$route.name == 'Parents' ? 'active' : ''} home`">
        <a @click="setOffset('home')" @mouseup="$router.push('/parents')">
          <div class="fhr fhr-home"></div>
          <span>{{$t('components.navigation.home')}}</span>
        </a>
      </li>
      <li :class="`${$route.name == 'Rewards' ? 'active' : ''} award`">
        <a @click="setOffset('award')" @mouseup="$router.push('/rewards')">
          <div class="fhr fhr-award"></div>
          <span>{{$t('components.navigation.rewards')}}</span>
        </a>
      </li>
      <li class="plus">
        <a @mouseup="openAddChore()">
          <div class="fhr fhr-plus"></div>
          <span></span>
        </a>
      </li>
      <li class="users">
        <a onclick="ChildSelectorModal.open()">
          <div class="fhr fhr-users"></div>
          <span></span>
        </a>
      </li>
      <li
        :class="`settings ${($route.fullPath.includes('settings') || $route.fullPath.includes('payment'))? 'active' : ''}`"
      >
        <a @click="setOffset('settings')" @mouseup="$router.push('/settings')">
          <div class="fhr fhr-settings"></div>
          <span>{{$t('components.navigation.settings')}}</span>
        </a>
      </li>
    </ul>
    <ul class="onebig" v-else>
      <li>
        <a @mouseup="$router.push('/parents')" class="home">
          <div>Back to Parent Mode</div>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      window: window,
      keyboardIsVisible: false,
      currentView: 'home',
      rewardModalIsOpen: null
    }
  },
  mounted() {
    const _this = this;
    function runner() {
      if (getCssVar($(".tabbar ul"), '--x').replace('px', '') > 0) clearInterval(_this.offsetInterval)
      else _this.setOffset('home')
    }
    this.offsetInterval = setInterval(runner, 500)

    this.onResize = () => this.setOffset(this.$data.currentView);
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    clearInterval(this.offsetInterval);
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    setOffset(x = "") {
      this.$data.currentView = x
      $(".tabbar ul").style.setProperty('--x', $(`.${x}`).offsetLeft + $(`.${x}`).offsetWidth / 2 + 'px');
    },
    openAddChore() { window.AddChoreModal.open(); }
  }
}
</script>
